import { render, staticRenderFns } from "./TemplateUsage.vue?vue&type=template&id=6095bb66&"
import script from "./TemplateUsage.vue?vue&type=script&lang=ts&"
export * from "./TemplateUsage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports